<template>
  <div>
    <v-dialog
      v-model="dialog_academicservice_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <!-- <pre>{{all_academicservice}}</pre> -->
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          Academicservice Settings
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_academicservice_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="py-4 pb-7">
            <v-menu close-on-content-click bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="float-right" color="primary" dark v-bind="attrs" v-on="on">
                  {{all_academicservice[select_items].curriculum_name!=''?all_academicservice[select_items].curriculum_name:''}}
                  <v-icon class="ml-1">mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="(items, index) in all_academicservice"
                  :key="index"
                  @click="select_items=index"
                >
                  <v-list-item-title>{{ items.curriculum_name!=''?items.curriculum_name:'' }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-card class="pt-2 my-3 mt-6" outlined>
            <v-card-title
              class="justify-center main-title pb-0"
            >{{all_academicservice[select_items].curriculum_name!=''?all_academicservice[select_items].curriculum_name:''}}</v-card-title>

            <v-data-table
              :headers="bachelor_headers"
              :items="all_academicservice[select_items].file"
            >
              <template v-slot:top>
                <v-col align="right">
                  <v-btn @click="dialog = true" color="primary" dark class="btn-responsive">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>New Academicservice
                  </v-btn>
                </v-col>
                <!-- dialog -->
                <v-dialog
                  v-model="dialog"
                  max-width="700px"
                  persistent
                  content-class="alldialog_settings"
                >
                  <v-card>
                    <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);"></v-card-title>
                    <v-row align="center" justify="center" class="mx-0 py-3 pt-5">
                      <v-col cols="10" class="py-0">
                        <v-form ref="form">
                          <v-text-field
                            v-model="academicservice_file_name"
                            label="File name"
                            outlined
                          ></v-text-field>
                        </v-form>
                      </v-col>

                      <v-col cols="10" class="py-0">
                        <v-card
                          v-if="show_file"
                          outlined
                          style="border:1px solid rgba(0, 0, 0, 0.38);"
                        >
                          <label :for="namefile">
                            <p class="pt-4 px-3 py-0">
                              Upload File
                              <v-icon class="float-right">mdi-cloud-upload</v-icon>
                            </p>
                          </label>
                        </v-card>
                        <v-card v-show="!show_file">
                          <v-card-title
                            class="py-2 pt-1"
                            v-for="(file,i) in file_upload"
                            :key="i"
                            v-show="i==0"
                          >
                            <v-list-item-avatar tile size="28">
                              <img src="https://img.icons8.com/color/48/000000/pdf.png" />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <!-- <pre>{{file_upload[0].name}}</pre> -->
                              <v-list-item-title>
                                {{
                                file.name
                                }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-btn icon @click="removeFile()">
                              <v-icon class="float-right">mdi-delete</v-icon>
                            </v-btn>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </v-row>

                    <file-upload
                      class="btn btn-primary dropdown-toggle"
                      input-id="photofile"
                      :directory="directory"
                      :accept="acceptfile"
                      :extensions="extensionfile"
                      :size="size || 0"
                      :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
                      :headers="headers"
                      :data="data"
                      @input-filter="inputFilter"
                      v-model="file_upload"
                      @input-file="inputFile"
                      ref="academicservice_media"
                    ></file-upload>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" text @click="close">Cancel</v-btn>
                      <v-btn
                        color="primary"
                        type="submit"
                        :loading="click"
                        @click="save()"
                        text
                      >Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <!-- detail in dataTable -->
              <template
                v-slot:item.no="{ item }"
              >{{ all_academicservice[select_items].file.indexOf(item) + 1 }}.</template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="deleteFile(item.curriculum_attachment_id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "vue-upload-component";
export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      click: false,
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      all_academicservice: [],
      select_items: 0,
      show_file: true,
      dialog_academicservice_setting: false,
      dialog: false,
      rule_field_is_empty: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      bachelor_headers: [
        {
          text: "No.",
          value: "no",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Name",
          value: "curriculum_attachment_name",
          // value: "file_name",
          sortable: false,
          align: "left",
          width: "30%",
        },
        {
          text: "File",
          value: "curriculum_attachment_path",
          // value: "file",
          sortable: false,
          align: "left",
          width: "30%",
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
      academicservice_file_name: "",
      bachelor_list: [],
      minSize: 1024,
      size: 1024 * 1024 * 10,
      acceptfile: ".pdf",
      extensionfile: "",
      directory: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: true,
      namefile: "photofile",
      file_upload: [],
    };
  },
  created() {
    this.getAcademicservice();
  },
  methods: {
    getAcademicservice() {
      let academicservice = [];
      for (let index = 7; index < 11; index++) {
        this.axios
          .get(process.env.VUE_APP_API + "/api/v1/curriculum/" + index)
          .then((response) => {
            // console.log(response.data[0]);
            // this.all_data = response.data;
            academicservice.push(response.data[0]);
          });
        this.all_academicservice = academicservice;
      }
    },
    openSetting() {
      this.academicservice_file_name = "";
      this.file_upload = [];
      this.dialog_academicservice_setting = true;
    },
    inputFile(newFile) {},
    inputFilter(newFile, oldFile, prevent) {
      this.show_file = false;
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    close() {
      this.click = false;

      this.academicservice_file_name = "";
      this.$refs.academicservice_media.remove(this.file_upload[0]);
      this.file_upload = [];
      this.dialog = false;
      this.show_file = true;
      // this.clear();
    },
    removeFile() {
      this.$refs.academicservice_media.remove(this.file_upload[0]);
      this.show_file = true;
    },
    deleteFile(id) {
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/curriculum/" + id,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data);

                if (response.data == "success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบข้อมูลสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "ไม่สามารถลบข้อมูลได้",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                }
                this.getAcademicservice();
                this.$emit("getacademicservice", "delete");
              });
          }
        });
    },
    postAcademicservice() {
      let form = new FormData();
      if (this.file_upload.length != 0) {
        for (let i = 0; i < this.file_upload.length; i++) {
          form = new FormData();
          form.append("file", this.file_upload[i].file);
          form.append("name", this.academicservice_file_name);
          this.axios
            .post(
              process.env.VUE_APP_API +
                "/api/v1/curriculum/upload/" +
                this.all_academicservice[this.select_items].curriculum_id,
              form,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);

              if (response.data == "upload success") {
                this.$swal.fire({
                  icon: "success",
                  title: "เพิ่มข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.click = false;
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "ไม่สามารถเพิ่มข้อมูลได้",
                  showConfirmButton: false,
                  timer: 1000,
                });
              }
              form = new FormData();
              this.getAcademicservice();
              this.$emit("getacademicservice", "add");
            });
        }
      }
    },
    save() {
      if (
        this.file_upload != [] &&
        this.academicservice_file_name != "" &&
        this.$refs.academicservice_media.files != ""
      ) {
        this.click = true;
        this.postAcademicservice();
        this.close();
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบไฟล์ หรือ ชื่อไฟล์",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
  },
};
</script>